'use strict';

module.exports = '3.11.0';



/*****************
 ** WEBPACK FOOTER
 ** ./~/algoliasearch/src/version.js
 ** module id = 95
 ** module chunks = 0
 **/